{
  "nav": "Tổng đài",
  "status": {
    "online": "Sẵn sàng nghe máy",
    "offline": "Chưa đăng ký máy nhánh",
    "busy": "Đang bận",
    "error": "Không đăng ký được tổng đài",
    "micDenied": "Trình duyệt chưa cho phép micro. Hãy cấp quyền rồi thử lại.",
    "httpsRequired": "Gọi trên trình duyệt cần HTTPS khi chạy production."
  },
  "actions": {
    "call": "Gọi",
    "busy": "Bận",
    "ready": "Sẵn sàng",
    "openRecord": "Mở hồ sơ",
    "createLead": "Tạo lead",
    "listen": "Nghe ghi âm",
    "link": "Gán hồ sơ",
    "close": "Đóng"
  },
  "incoming": {
    "title": "Cuộc gọi đến",
    "unknown": "Số chưa có hồ sơ",
    "multiple": "Nhiều hồ sơ khớp số này"
  },
  "contact": {
    "title": "Liên hệ",
    "empty": "Chưa có nhật ký liên hệ",
    "add": "Ghi liên hệ",
    "sourceManual": "Ghi tay",
    "sourceOmicall": "Cuộc gọi",
    "inbound": "Gọi vào",
    "outbound": "Gọi ra",
    "local": "Nội bộ",
    "duration": "{{seconds}} giây",
    "missed": "Nhỡ máy",
    "ringing": "Đang đổ chuông",
    "answered": "Đã bắt máy",
    "hangup": "Đã kết thúc"
  },
  "errors": {
    "loadSip": "Không lấy được máy nhánh",
    "register": "Đăng ký tổng đài thất bại",
    "makeCall": "Không gọi được. Kiểm tra tai nghe và máy nhánh.",
    "notConfigured": "Chưa gọi được vì chưa cấu hình tổng đài hoặc chưa gán máy nhánh. Vào Cài đặt → Tích hợp.",
    "lookup": "Không tìm được hồ sơ theo số",
    "save": "Không lưu được nhật ký liên hệ"
  }
}
